import React from "react";
import { useNavigate } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Chip } from "@mui/material";

import DataTable from "../../components/tables/DataTable";
import { Column } from "../../components/tables/interfaces";
import { axiosWorkflowIntance } from "../../services/api-client";
import { V1ListNamespacesResponse } from "../../services/workflow-server";

export interface NamespaceType {
  id?: string;
  name?: string;
  description?: string;
  ownerEmail?: string;
  isGlobalNamespace?: boolean;
}

const NamespacesList = () => {
  const navigate = useNavigate();

  const columns: Column[] = [
    { id: "name", label: "Name" },
    { id: "description", label: "Description" },
    { id: "ownerEmail", label: "Owner" },
    { id: "state", label: "State" },
    { id: "retentionPeriod", label: "Retention Period(Hours)", type: 'numeric' },
    {
      id: 'tags', label: 'Tags', render: (value: any) => {
        if (Array.isArray(value)) {
          return value.map((item, index) => <Chip key={index} label={item} size="small" />);
        } else if (typeof value === 'object' && value !== null) {
          return Object.entries(value).map(([key, val]) => (
            <Chip key={key} label={`${key}: ${val as React.ReactNode}`} size="small" style={{ marginRight: 4, marginBottom: 4 }} />
          ));
        } else {
          return <span>{value}</span>;
        }
      }
    },
  ];

  const fetchData = async (query?: { pageSize?: number; nextPageToken?: string } | { page?: number; limit?: number }) => {
    if (query && ('pageSize' in query || 'nextPageToken' in query)) {
      try {
        const response = await axiosWorkflowIntance.api.workflowServiceListNamespaces(query);
        return response.data;
      } catch (error) {
        console.error("Error occured while fetching Namespaces ", error)
        return [] as V1ListNamespacesResponse
      }
    }
    else {
      return [] as V1ListNamespacesResponse
    }

  };

  const dataExtractor = (response: V1ListNamespacesResponse): any[] => {
    return (response.namespaces || []).map(namespace => ({
      id: namespace.namespaceInfo?.id,
      name: namespace.namespaceInfo?.name,
      description: namespace.namespaceInfo?.description,
      ownerEmail: namespace.namespaceInfo?.ownerEmail,
      state: namespace.namespaceInfo?.state,
      retentionPeriod: namespace.config?.workflowExecutionRetentionTtl ? parseInt(namespace.config?.workflowExecutionRetentionTtl.replace('s', '')) / 3600 : 0,
      tags: namespace.namespaceInfo?.data,
    }));
  };

  const nextPageTokenExtractor = (response: V1ListNamespacesResponse): string | undefined => response.nextPageToken;

  return (
    <Box>
      <Box sx={{ m: 2, display: 'flex'}} >
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate("add")} sx={{ mr: 2 }}>
          Add Namespace
        </Button>
      </Box>
      {/* <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography sx={{ m: 2 }} variant="h4">
          Namespaces
        </Typography>
        <Button variant='contained' startIcon={<AddIcon />} onClick={() => navigate("add")} sx={{ mr: 2 }}>
          Add Namespace
        </Button>
      </Box> */}
      <Box>
        <DataTable
          columns={columns}
          fetchData={fetchData}
          dataExtractor={dataExtractor}
          nextPageTokenExtractor={nextPageTokenExtractor}
          stickyHeader
          tableContainerMaxHeight={'calc(100vh - 220px)'}
        />
      </Box>
    </Box>
  );
};

export default NamespacesList;